import React from "react";
import ReactDOM from "react-dom";

import { Providers } from "base/Providers";
import reportWebVitals from "utils/reportWebVitals";

import "styles/index.scss";

// preload external lib styles
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-toastify/dist/ReactToastify.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

ReactDOM.render(
  <React.StrictMode>
    <Providers />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
